
import { Avatar, Breadcrumb, Flex, Space, Spin } from "antd";
import { getBase64 } from "components/elements/upload/Upload.utils";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ReactComponent as UserIcon } from "../../../assets/icon/userIcon.svg";
import { ReactComponent as EditIcon } from "../../../assets/images/edit.svg";
import { PERMISSIONS_CONFIG } from "../data/employeeInfoGeneralProfile";
import useEmployeeContactInfo from "../hooks/useEmployeeContactInfo";
import useEmployeeEdit from "../hooks/useEmployeeEdit";
import useEmployeeEmploymentInfo from "../hooks/useEmployeeEmploymentInfo";
import useEmployeeGeneralInfoProfile from "../hooks/useEmployeeGeneralInfoProfile";
import useEmployeeSalarySalary from "../hooks/useEmployeeSalarySalary";
import EmployeeContactInfoProfile from "./EmployeeContactInfoProfile";
import EmployeeEmploymentInfoComponent from "./EmployeeEmploymentInfo";
import EmployeeImageProfileModal from "./EmployeeImageProfileModal";
import EmployeeInfoGeneralInfoComponent from "./EmployeeInfoGeneralInfo";
import EmployeeMenuProfile from "./EmployeeMenuProfile";
import EmployeeSalaryInfoComponent from "./EmployeeSalaryInfoComponent";
import { useTranslation } from "react-i18next";

function EmployeeInfoGeneralProfile({
  isModalOpen = false,
  generalInfo = [],
  initialValues = {},
  showModal = () => { },
  handleCancel = () => { },
  onImageSubmit = () => { },
  isLoading,
}) {

  const { t } = useTranslation();
  const [selectMenu, setSelectMenu] = useState('employee_info')
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();

  function onchangeMenu(params) {
    console.log("param", params);
    setSelectMenu(params)
  }
  const com = useEmployeeEdit(false)
  const employeeEmploymentInfoProps = useEmployeeEmploymentInfo();
  const employeeEmployeeInfoProps = useEmployeeGeneralInfoProfile();
  const contactInfoProps = useEmployeeContactInfo()
  const employeeSalarySalaryProps = useEmployeeSalarySalary();
  const pageForm = "PROFILE";
  // console.log("com", com);
  const roles = useSelector((state) => state.company.roles);
  const [permissions, setPermissions] = useState({})
  const getPermissions = (menu) => {
    const permissions = PERMISSIONS_CONFIG[menu] || {};
    return Object.keys(permissions).reduce((acc, perm) => {
      acc[perm] = roles.includes(permissions[perm]);
      return acc;
    }, {});
  };

  const menuBreadcrumbMapping = {
    'employee_info': t('employee.employee_info.header'),
    'employment': t('employee.employment.header'),
    'salary': t('employee.salary.header')
  }

  const menuList = [
    { key: 'employee_info', label: t('employee.employee_info.header'), rule: "ACCESS_PROFILE|EMPLOYEE_INFO" },
    { key: 'employment', label: t('employee.employment.header'), rule: "ACCESS_PROFILE|EMPLOYMENT_INFO" },
    { key: 'salary', label: t('employee.salary.header'), rule: "ACCESS_PROFILE|SALARY_INFO" },
  ];

  const filteredMenuList = menuList
    .filter(item => roles.includes(item.rule))
    .map(item => ({ key: item.key, label: item.label }));

  useEffect(() => {
    if (filteredMenuList.length > 0) {
      setSelectMenu(filteredMenuList[0].key);
    }
  }, [roles]);

  useEffect(() => {
    const newPermissions = getPermissions(selectMenu);
    setPermissions(newPermissions);
  }, [selectMenu, roles]);


  useEffect(() => {
    if (initialValues?.employeeImage && initialValues?.employeeImage !== "" && initialValues?.employeeImage !== null) {
      setLoading(true);
      getBase64(initialValues?.employeeImage, (url) => {
        setImageUrl(url);
      });
    }
  }, [initialValues.employeeImage]);

  const getPage = useCallback(() => {
    switch (selectMenu) {
      case "employee_info":
        return permissions?.ACCESS && (
          <Spin spinning={isLoading}>
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
              <EmployeeImageProfileModal isModalOpen={isModalOpen} handleCancel={handleCancel} handleOk={onImageSubmit} imageUrl={imageUrl} permissions={permissions} />
              <Flex align="end" justify="center">
                <Avatar
                  size={125}
                  src={initialValues?.employeeImage ? imageUrl : <UserIcon />}
                />
                {roles.includes("UPDATE_PROFILE|EMPLOYEE_INFO") && (
                  <EditIcon style={{ color: "#42526D", marginLeft: "-20px", cursor: "pointer" }} onClick={showModal} pageForm={pageForm} />)}
              </Flex>

              <EmployeeInfoGeneralInfoComponent
                generalInfo={employeeEmployeeInfoProps.generalInfo}
                view={true}
                {...employeeEmployeeInfoProps}
                pageForm={pageForm}
                permissions={permissions} />
              <EmployeeContactInfoProfile {...contactInfoProps} pageForm={pageForm} permissions={permissions} />
            </Space>
          </Spin>
        );
      case "employment":
        return permissions?.ACCESS && (<EmployeeEmploymentInfoComponent view={true} {...employeeEmploymentInfoProps} pageForm={pageForm} permissions={permissions} />);
      case "salary":
        return permissions?.ACCESS && (<EmployeeSalaryInfoComponent {...employeeSalarySalaryProps} pageForm={pageForm} permissions={permissions} />);
      default:
        return <div />;
    }
  }, [selectMenu, com, employeeEmploymentInfoProps.initialValues]);

  return (
    <Space direction="vertical" size={24} style={{ width: "100%" }}>
      <Flex vertical>
        <Breadcrumb items={[
          { title: t("home.header"), href: "/" },
          { title: t("employee.label.profile"), href: "" },
          { title: menuBreadcrumbMapping[selectMenu] || null }
        ]} />
        <h2>{menuBreadcrumbMapping[selectMenu] || t("employee.label.profile")}</h2>
      </Flex>
      <Flex vertical style={{ rowGap: "16px" }}>
        <EmployeeMenuProfile
          selectedMenu={selectMenu}
          onSelectMenu={onchangeMenu}
          menuList={filteredMenuList}
        />
        {getPage()}
      </Flex>
    </Space>
  );
}

export default EmployeeInfoGeneralProfile;
